import { createIconComponent } from '../../factory/create-icon-component';
export const AlignJustifyIcon = createIconComponent(
  'AlignJustifyIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00001 19.9999H3.00001M21 19.9999H10M3 12H21M18 4H21M3 4H14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
